module.exports = __webpack_public_path__ + "img/template005.cc2b39b1.png";